export const PAINT_COMPETITOR_CATEGORIES = [
  'Anticorrosivos',
  'Resistencia Química',
  'Autonivelante',
  'Barnices',
  'Antifouling',
  'Primers',
  'Intermedias',
  'Acabados',
  'Marinos',
  'Pisos',
  'Especiales',
];

export const PAINT_COMPETITOR_CHEMISTRIES = [
  'Epoxy 2K curada con poliamina',
  'Epoxy 2K curado con poliamida',
  'Epoxy 2K curado con fenalcamina',
  'Epoxy 2K',
  'Epóxico fenalcamina',
  'Alquídico modificado',
  'Alquídico',
  'Poliuretano alifático',
  'Poliuretano 2K poliéster',
  'Poliuretano acrílico',
  'Poliuretano 2K',
  'Poliurea aspártica',
  'Acrílico',
  'Acrílico base agua',
  'Silano',
  'Acrilato de sililo (autopulimentante)',
  'Copolímero (pulimentante)',
  'Copolímero (renovable)',
  'Zinc inorgánico',
  'Silicato de zinc',
];

export const PAINT_COMPETITOR_APPLICATIONS = [
  'Imprimación',
  'Intermedia',
  'Acabado',
  'Sistema monocapa',
  'Inmersión',
  'No inmersión',
  'Mantenimiento',
  'Reparación',
  'Pisos',
  'Antifouling',
];

const collectValues = (items = [], key, defaults = []) => {
  const extras = items.flatMap((item) => {
    const value = item?.[key];
    if (Array.isArray(value)) return value;
    return value ? [value] : [];
  }).filter(Boolean);
  return Array.from(new Set([...defaults, ...extras]));
};

export const collectCompetitorCategories = (items = []) =>
  collectValues(items, 'category', PAINT_COMPETITOR_CATEGORIES);

export const collectCompetitorChemistries = (items = []) =>
  collectValues(items, 'chemistry', PAINT_COMPETITOR_CHEMISTRIES);

export const collectCompetitorApplications = (items = []) =>
  collectValues(items, 'applications', PAINT_COMPETITOR_APPLICATIONS);
